import React from 'react';
import DeliveryBanner from './DeliveryBanner';
import TopBar from './TopBar';
import Navigation from './Navigation';

const Header: React.FC = () => {
  return (
    <header data-site-header className="sticky top-0 z-50 w-full">
      <DeliveryBanner />
      <TopBar />
      <Navigation />
    </header>
  );
};

export default Header;
